<template>
  <div class="login-container" v-on:click.stop>
    <span>Login with your credentials</span>
    <div class="login mt-4">
      <form v-on:submit="login">
        <div class="form-group">
          <label for="email">Email address</label>
          <input
            type="email"
            name="email"
            id="email"
            class="form-control"
            v-model="email"
            placeholder="Enter your email address"
            v-on:click.stop
          />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            name="password"
            id="password"
            class="form-control"
            v-model="password"
            placeholder="Enter your password"
            v-on:click.stop
          />
        </div>
        <div class="form-group button-group error" v-if="error">
          <p>{{ error }}</p>
        </div>
        <div class="form-group pt-2" v-on:click.stop @click="toggleRemember">
          <input type="checkbox" id="remember"  v-on:click.stop/>
          <label for="remember">Remember me</label>
        </div>
        <div class="form-group button-group">
          <button type="submit" class="btn btn-red" v-on:click.stop>
            <span class="spinner-border spinner-border-sm" role="status" v-if="isLoading"></span>
            <span v-else>Login</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Login",
  data: function() {
    return {
      email: "",
      password: "",
      isLoading: false,
      error: "",
      remember: false
    };
  },
  methods: {
    toggleRemember() {
      this.remember = !this.remember;
    },
    login: function(e) {
      e.preventDefault();
      this.error = "";

      if (!this.email || !/@/.test(this.email)) {
        this.error = "Please enter your email address.";
      } else if (!this.password || !this.password.trim()) {
        this.error = "Please enter your password.";
      } else {
        this.isLoading = true;
        axios
          .post("/api/users/session/admin/create", {
            email: this.email,
            password: this.password,
            remember: this.remember
          })
          .then(response => {
            this.isLoading = false;
            this.$store.commit("session/updateLogin", {
              isLoggedIn: true,
              name: response.data.user.name,
              id: response.data.user.id,
              properties: response.data.user.properties
            });
            if (response.data.user.properties.length >= 1) {
              this.$router.push("/properties");
            } else {
              if (window.localStorage.getItem("oldPath")) {
                this.$router.push(window.localStorage.getItem("oldPath"));
                window.localStorage.removeItem("oldPath");
              } else {
                this.$router.push("/dashboard");
              }
            }
          })
          .catch(error => {
            this.isLoading = false;
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              this.error = error.response.data.error;
            } else {
              this.error =
                "Sorry, something went wrong. Please try again later.";
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables";
  [type="checkbox"]:not(:checked),
  [type="checkbox"]:checked {
    position: absolute;
    left: 0;
    opacity: 0.01;
  }
  [type="checkbox"]:not(:checked) + label,
  [type="checkbox"]:checked + label {
    position: relative;
    padding-left: 40px;
    font-family: Helvetica;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
  }

  [type="checkbox"]:not(:checked) + label:before,
  [type="checkbox"]:checked + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 25px;
    height: 25px;
    border: 1px solid rgb(0, 0, 0);
    background: #FFF;
    box-shadow: inset 0 1px 3px rgba(0,0,0, .1), 0 0 0 rgba(203, 34, 237, .2);
    -webkit-transition: all .275s;
        transition: all .275s;
  }

  /* checked mark aspect */
  [type="checkbox"]:not(:checked) + label:after,
  [type="checkbox"]:checked + label:after {
    content: '';
    width:19px;
    height: 19px;
    position: absolute;
    top: 3px;
    left: 3px;
    background-color: #fc5657;
    line-height: 0;
    -webkit-transition: all .2s;
        transition: all .2s;
  }

  [type="checkbox"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
        transform: scale(0);
  }

  [type="checkbox"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1) rotate(0);
        transform: scale(1) rotate(0);
  }
.login-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  > span {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 30px;
    color: #10176f;
    letter-spacing: -0.05px;
    line-height: 40px;
  }
  .login {
    height: min-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

form {
  width: 100%;
  ::placeholder {
    font-family: Helvetica;
    font-size: 14px;
    color: #B6B6B6;
    letter-spacing: 0;
    line-height: 30px;
  }
  label {
    font-family: Helvetica;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 30px;
  }
  input {
    // pointer-events: none;
    z-index: 999999;
  }
}

div.logos {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2em;

  img.logo {
    width: 150px;
    height: auto;
    margin-left: 10px;
    margin-right: 10px;
  }
}

div.button-group {
  margin-top: 3em;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  > button {
    width: fit-content;
    border-radius: 8px;
    padding: 12px 40px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 700;
    color: white;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
  }
}

div.error {
  p {
    font-size: 0.875rem;
    font-weight: 500;
    color: $red;
    margin: 0;
  }
}
</style>
